export default function (
  $rootScope,
  $stateParams,
  Authentication,
  $injector,
  GoogleAuth,
  authService,
  $location,
  localStorageService,
  $state
) {
  "ngInject";
  $rootScope.isLoggedin = localStorageService.get("authdata") !== null;
  GoogleAuth.initialize();
  if (!$rootScope.isLoggedin) {
    const back = Object.assign({}, { back: $location.$$url });
    $location.path("/login/").search(back);
  }

  $rootScope.$on("$locationChangeStart", () => {
    if ($rootScope.isLoggedin) {
      if ($location.absUrl().includes("login")) {
        $location.path("/");
      }
      if ($location.absUrl().includes("back")) {
        $location.url($location.path());
      }
    }
  });
  $rootScope.$on("event:auth-loginRequired", () => {
    const toRefreshToken = Authentication.getRefreshToken();
    const request = $injector
      .get("Login")
      .refresh({ refresh_token: toRefreshToken });
    $rootScope.isRefreshingToken = true;

    request.$promise.then(
      (response) => {
        Authentication.updateToken(response);
        authService.loginConfirmed("success", (config) => {
          $rootScope.isLoggedin = true;
          return config;
        });

        const reload = () => {
          $state.transitionTo($state.current, $stateParams, {
            reload: true,
            inherit: false,
            notify: true,
          });
        };

        reload();

        $rootScope.isRefreshingToken = false;
      },
      () => {
        const back = Object.assign({}, { back: $location.$$url });
        localStorageService.remove("authdata");
        authService.loginCancelled();
        $rootScope.isLoggedin = false;
        $location.path("/login/").search(back);
        $rootScope.isRefreshingToken = false;
      }
    );
  });

  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;
}



// WEBPACK FOOTER //
// ./src/core/auth.js